import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal-top" }
const _hoisted_3 = { class: "modal-footer" }

import { ref } from 'vue';
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import CloseButton from '@lmt-rpb/Atoms/CloseButton/CloseButton.vue';

const welcomeText = 'Willkommen zurück!';
const welcomeTextBody = 'Bitte aktualisieren Sie Ihre Suche, da sich die Angebote unter Umständen geändert haben.';
const updateButton = 'Aktualisieren';


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeBackModal',
  props: {
    timeout: { default: 30 * 60 * 1000 }
  },
  emits: ['SmallModal:Close'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const timeoutId = ref();

const showModal = ref(false);

const props = __props;

const clearTimer = (): void => {
	clearTimeout(timeoutId.value);
};

const reSetAndStartTimer = (): void => {
	clearTimer();

	timeoutId.value = setTimeout(() => {
		showModal.value = true;
		clearTimer();
	}, props.timeout);
};

const closeModal = (): void => {
	showModal.value = false;
	reSetAndStartTimer();
};

const openModal = (): void => {
	showModal.value = true;
};

const emit = __emit;

const onCloseClick = () => {
	emit('SmallModal:Close');
};

__expose({ closeModal, openModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (showModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal modal-mask",
            onClick: _withModifiers(onCloseClick, ["self"])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(CloseButton, {
                  class: "modal-close",
                  "rem-size": 2.133,
                  onClick: closeModal
                })
              ]),
              _createElementVNode("h2", { class: "modal-header" }, _toDisplayString(welcomeText)),
              _createElementVNode("div", { class: "modal-body" }, _toDisplayString(welcomeTextBody)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(RoundedButton, {
                  class: "modal-footer__button modal-footer__button-left",
                  theme: "extra",
                  onClick: onCloseClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(updateButton))
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})